import { useRef } from "react";
import {
  AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter,
  AlertDialogHeader, AlertDialogOverlay, Button,
} from "@chakra-ui/react";

interface ConfirmBenefitsEmailDialogProps {
  isOpen: boolean;
  onClose: () => void;
  candidateName: string;
  isSending: boolean;
  onConfirm: () => void;
}

export const ConfirmBenefitsEmailDialog = ({
  isOpen, onClose, candidateName, isSending, onConfirm,
}: ConfirmBenefitsEmailDialogProps) => {
  const cancelRef = useRef<HTMLButtonElement>(null);
  return (
    <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="md" fontWeight="bold">Enviar e-mail de benefícios</AlertDialogHeader>
          <AlertDialogBody fontSize="sm">
            Confirma o envio do e-mail de benefícios para <strong>{candidateName}</strong>?
          </AlertDialogBody>
          <AlertDialogFooter gap={2}>
            <Button ref={cancelRef} variant="ghost" size="sm" onClick={onClose}>Cancelar</Button>
            <Button
              colorScheme="blue" size="sm"
              isLoading={isSending} loadingText="Enviando..."
              onClick={async () => { onClose(); onConfirm(); }}
            >
              Sim, enviar
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
